import useSSRLayoutEffect from '~/client/hooks/useSSRLayoutEffect';
import Cookie from '~/shared/utils/Cookie';
import getTopLevelDomain from '~/shared/utils/domain/getTopLevelDomain';

enum Navigation {
  BACK = 'navigation.back',
  FORWARD = 'navigation.forward',
}

const useSiteReferrer = () => {
  useSSRLayoutEffect(() => {
    clearNavigationCookies();
    setNavigationCookies();
  }, []);
};

const clearNavigationCookies = () => {
  Cookie.remove(Navigation.BACK);
  Cookie.remove(Navigation.FORWARD);
};

const setNavigationCookies = () => {
  const fullPath = global.location.href;
  const domain = getTopLevelDomain(global?.location?.host);
  sessionStorage.setItem('referer', fullPath);
  Cookie.set(Navigation.BACK, fullPath, { domain });
  Cookie.set(Navigation.FORWARD, fullPath, { domain });
};

export default useSiteReferrer;
